module.exports = {
    assemble: {
        我的: 'Management Dashboard',
        积分商城: 'Points Redemption',
        消息: 'News',
        提醒: 'Remind',
        退出: 'Exit',
        客户管理: 'Customer Management',
        我的积分: 'My Points',
        个人资料: 'personal Data',
        查看详情: 'Detail',
        我的客户: 'My Client',
        报备: 'Submit',
        导入: 'Import',
        导出: 'Export',
        搜索: 'Search For',
        清空: 'Clean',
        全选: 'Select All',
        全不选: 'Deselect All',
        已选删除: 'Delete',
        已选彻底删除: 'Selected to be completely deleted',


        客户头像: 'Avatar',
        客户名字: 'Name',
        联系电话: 'Phone Number',
        项目: 'Item',
        状态: 'Status',
        操作: 'Operate',

        全部: 'whole',
        已联系没兴趣: 'Not Interested',
        正在沟通中: 'In Progress',
        已完成: 'Completed',
        介绍费已到账: 'Paid',

        详情: 'Details',
        编辑: 'Edit',
        删除: 'Delete',
        完成: 'Complete',


        名: 'First Name',
        姓: 'Last Name',
        电话号码: 'Phone Number',
        城市: 'City',
        邮箱: 'Email Address',



        确认: 'Confirm',
        取消: 'Back',

        客户信息: 'CUSTOMER',
        添加新用户: 'Add a new user',
        跟进进度: 'Follow up on progress',
        更改详情: 'Change details',
        确定删除: 'Are you sure you want to delete this user?',


        商品兑换记录: 'Product exchange records',
        代金券兑换记录: 'Voucher redemption record',
        现金兑换记录: 'Cash exchange records',


        共计: 'Total',
        积分兑换: 'Redemption of points',
        积分数量: 'Number of points',
        到账时间: 'Date',
        返回: 'Return',


        商品图片: 'Commodity picture',
        商品名称: 'Name',
        兑换金额: 'Redemption Amount',
        类型: 'Type',
        兑换时间: 'Redemption Time',
        比例金额: 'Amount to be paid',



        已使用: 'Used',
        未使用: 'Not Used',
        积分: 'Integral',
        代金券: 'Voucher',

        代金券名称: 'Name of voucher',
        代金券面值: 'Coupon face value',
        使用状态: 'Status',
        代金券码: 'Voucher code',


        转账方式: 'Payment Method',
        真实姓名: 'Name',

        个人资料: 'Profile',
        基本信息: 'Basic information',
        编辑用户信息: 'Edit user information',
        头像: 'Avatar',
        限图片: 'Limited to images',
        以内: 'Within',



        用户名: 'User name',
        手机号: 'Phone Number',
        密码: 'Password',
        修改: 'Modify',



        兑换商品: 'Redemption of goods',
        请选择兑换类型: 'Type',
        兑换价格: 'Conversion Crice',
        剩余金额: 'Remaining amount',
        立即兑换: 'Redeem now',


        现金兑换: 'Cash exchange',
        确定: 'Determine',
        剩余积分: 'Residual integral',
        描述: 'Redemption of vouchers will result in an additional 10% bonus, which can be used for our online shopping mall, heating and cooling purchase, installation, and maintenance services (vouchers cannot be used across stores, can only be used for Hengzhi heating and cooling in most regions)',

        代金券兑换: 'Voucher redemption',
        可兑换代金券: 'Convertible voucher',
        购买: 'Purchase',


        修改密码: 'Change password',
        手机号: 'Phone Number',

        新密码: 'New Password',
        确认密码: 'Confirm Password',
        兑换成功: 'You have successfully redeemed. The redemption link will be sent to your email. Please check it carefully',

        提示: 'Tips',
        确定兑换代金券:'Are you sure you want to redeem this voucher?',

        支票:'Check',
        EMT转账:'EMT transfer',
        发送验证码:'Send verification code',
        输入新密码和确认新密码需要一致:'The new password must be the same as the new password',

        排序:'sort by date',


        
        登录:'Login',
        手机号登录:'Mobile',
        邮箱登录:'Email',
        密码:'Password',
        自动登录:'Automatic login',
        验证码登录:'Verification code login',
        注册账号:'Register an account',
        忘记密码:'Forgot password',
        发送验证码:'verification code',
        账号登录:'Account login',

        注册:'Register',
        用户名:'Username',
        密码:'Password',


        忘记密码:'Forgot password',
        新密码:'New password',
        确认新密码:'Confirm new password',

        客户名称:'Name',

        请输入手机号:"Enter your moblie",
        请输入邮箱地址:"Enter your email",
        请输入密码:"Enter password",
        验证码:"Verification code",
        请输入验证码:"Enter verification code",

        请输入用户名:"Enter your username",
        请输入新密码:"Enter your new password",
        输入新密码和确认新密码需要一致:"The new password must be the same as the new password",

        开始日期:"Start date",
        结束日期:"End date",
        至:"to",
        请输入手机号:"Please enter your phone number",
        请输入邮箱地址:"Please enter your email address",
        请输入手机号内的验证码:"Please enter the verification code in the phone number",
        请输入验证码:"Please enter the verification code",
        请输入邮箱内的验证码:"Please enter the verification code in your email",
        请输入确认密码:"Enter confirm Password",

        邮箱地址:'Address',


    }
}